/** @format */
import { DateHelperTs } from '../../helpers/DateHelperTs';

export class CycleComponentRefreshConfiguration {
    getDays = (): number => {
        const date = new Date();
        const currentDate = date.toLocaleDateString();
        const lastDayMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString();
        return DateHelperTs.dateDiff(currentDate, lastDayMonth, 'days');
    };
}
